import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../Checkbox';

export default class extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    tooltipText: PropTypes.string,
  }

  static defaultProps = {
    tooltipText: 'This is a core question. It is always included and required during member applications.',
  }

  renderCheckbox(id) {
    return (
      <Checkbox id={id} checked disabled
        tooltipText={this.props.tooltipText} />
    );
  }

  render() {
    const question = this.props.question;

    const pickedCheckbox = this.renderCheckbox(`question-${question.field}-checkbox`);
    const requiredCheckbox = this.renderCheckbox(`question-${question.field}-require-checkbox`);

    return (
      <tr>
        <td>{pickedCheckbox}</td>
        <td><b>{question.fieldName}</b></td>
        <td>{question.label}</td>
        <td>{question.type}</td>
        <td>{requiredCheckbox}</td>
      </tr>
    );
  }
}
